import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Container,
  Divider,
  Grid,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Backdrop,
  CircularProgress,
  Snackbar,
  Box
} from '@material-ui/core';
import Page from 'src/components/Page';
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import image from 'src/assets/images/konsep_2.jpg';
import { DataGrid } from '@material-ui/data-grid';
import * as XLSX from 'xlsx';
import axios from 'src/utils/axios';
import InfoIcon from '@mui/icons-material/Info';
import moment from 'moment';
import Alert from 'src/components/Alert';
import SatisOrnekExcel from 'src/assets/AssemblyBudgetExcels/1_SatışÖrnekExcelData.xlsx';
import MontajOrnekExcel from 'src/assets/AssemblyBudgetExcels/2_MontajAğırlıkÖrnekExcelData.xlsx';
import FiiliMontajOrnekExcel from 'src/assets/AssemblyBudgetExcels/3_MontajFiiliAdetÖrnekExceli.xlsx';
import MontajFiyatOrnekExcel from 'src/assets/AssemblyBudgetExcels/4_FiyatMontajHesaplamaÖrnekExcelData.xlsx';
import AnaVeriOrnekExcel from 'src/assets/AssemblyBudgetExcels/AnaVeriHazırlamaÖrnekExcelData.xlsx';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  media: {
    height: 300,
  },
  customCardContent: {
    '&.MuiCardContent-root:last-child': {
      paddingBottom: '0.65rem'
    }
  },
  dataGridHeader: {
    color: '#ff9800',
    fontWeight: 'bold',
    fontSize: '0.8rem'
  },
}));

const steps = [
  'Satış Adetleri Excel',
  'Montajlama Oranı Excel',
  'Fiili Montaj Adet Excel',
  'Montaj Fiyat Excel'
];

function AssemblyBudget() {
  const classes = useStyles();

  const [columns, setColumns] = useState([]);  // Excel'e göre dinamik kolonlar
  const [rows, setRows] = useState([]);  // Excel'e göre dinamik satırlar

  const [excelData, setExcelData] = useState([]);
  const [excelType, setExcelType] = useState(0);

  const [salessuccessState, setSalesSuccessState] = useState(false);
  const [ratiosuccessState, setRatiosuccessState] = useState(false);
  const [assemblysuccessState, setAssemblysuccessState] = useState(false);
  const [installationPriceSuccessState, setInstallationPriceSuccessState] = useState(false);

  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [loading, setLoading] = useState(false);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  const stepStates = [salessuccessState, ratiosuccessState, assemblysuccessState, installationPriceSuccessState];


  const handleUpload = (type) => {
    setExcelType(type);
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.xlsx, .xls';
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (evt) => {
          const binaryStr = evt.target.result;
          const workbook = XLSX.read(binaryStr, { type: 'binary' });

          // İlk sayfayı alıyoruz
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName], { header: 1 });

          if (worksheet.length > 0) {
            // İlk satırdaki değerler kolonlar olacak
            const newColumns = worksheet[0].map((col, index) => ({
              field: `col_${index}`,
              headerName: col,
              width: index === 1 ? 300 : 200,  // İkinci kolon için genişlik 300, diğerleri 200
              headerClassName: classes.dataGridHeader
            }));

            // Diğer satırları veri olarak ekliyoruz
            const newRows = worksheet.slice(1).map((row, rowIndex) => {
              const rowData = {};
              row.forEach((cell, cellIndex) => {
                rowData[`col_${cellIndex}`] = cell;
              });
              return { id: rowIndex + 1, ...rowData };
            });

            // Column ve row'ları state'e set et
            setColumns(newColumns);
            setRows(newRows);

            // Excel verilerini sakla
            setExcelData(newRows); // Gelen verileri sakla
          }
        };
        reader.readAsBinaryString(file);
      }
    };
    fileInput.click();
  };

  const transformDataForApi = (data) => {
    if (excelType === 1) {
      return data.map(item => ({
        RowId: item.col_0,
        ProductLevelThree: item.col_1,
        ProductLevelFour: item.col_2,
        Brand: item.col_3,
        ModelType: item.col_4,
        PlaceOfSupply: item.col_5,
        Year: item.col_6,
        January: item.col_7,
        February: item.col_8,
        March: item.col_9,
        April: item.col_10,
        May: item.col_11,
        June: item.col_12,
        July: item.col_13,
        August: item.col_14,
        September: item.col_15,
        October: item.col_16,
        November: item.col_17,
        December: item.col_18,
        BudgetType: item.col_19
      }));
    }
    else if (excelType === 2) {
      return data.map(item => ({
        RowId: item.col_0,
        ProductLevelThree: item.col_1,
        ProductLevelFour: item.col_2,
        Brand: item.col_3,
        ModelType: item.col_4,
        PlaceOfSupply: item.col_5,
        Year: item.col_6,
        January: item.col_7,
        February: item.col_8,
        March: item.col_9,
        April: item.col_10,
        May: item.col_11,
        June: item.col_12,
        July: item.col_13,
        August: item.col_14,
        September: item.col_15,
        October: item.col_16,
        November: item.col_17,
        December: item.col_18,
        BudgetType: item.col_19,
        targetRatio: item.col_20
      }));
    } else if (excelType === 3) {
      return data.map(item => ({
        RowId: item.col_0,
        ProductLevelThree: item.col_1,
        ProductLevelFour: item.col_2,
        Brand: item.col_3,
        ModelType: item.col_4,
        PlaceOfSupply: item.col_5,
        Year: item.col_6,
        ProductGroup: item.col_7,
        January: item.col_8,
        February: item.col_9,
        March: item.col_10,
        April: item.col_11,
        May: item.col_12,
        June: item.col_13,
        July: item.col_14,
        August: item.col_15,
        September: item.col_16,
        October: item.col_17,
        November: item.col_18,
        December: item.col_19,
      }));
    } else if (excelType === 4) {
      return data.map(item => ({
        ProductLevelThree: item.col_0,
        ProductLevelFour: item.col_1,
        Brand: item.col_2,
        ModelType: item.col_3,
        Year: item.col_4,
        PriceGroup: item.col_5,
        CustomerServiceProduct: item.col_6,
        TargetCalculationYear: item.col_7,
        CalculationStartMonth: item.col_8,
        CalculationEndMonth: item.col_9,
        FirstPeriodRaiseRatio: item.col_10,
        SecondPeriodRaiseRatio: item.col_11
      }));
    }
    else {
      return [];
    }
  };


  const handleAssemblyAndSalesInsertNewData = (type) => {
    const data = transformDataForApi(excelData);

    const urlMap = {
      1: "AssemblyBudgetSalesInsertExcel",
      2: "AssemblyBudgetRatioInsertExcel",
      3: "AssemblyBudgetInsertExcel",
      4: "InstallationBudgetPriceCalculationInsertExcel"
    };
    const url = urlMap[excelType] || "";

    if (url) {
      const config = {
        headers: { 'Content-Type': 'application/json' }
      }
      setLoading(true);
      axios.post(`/${url}`, data, config)
        .then(response => {
          if (response.data.ErrorCode === '1000') {
            setresponseMessage(response.data.ErrorDescription)
            setUyariTip("error");
            setUyari(true);
          } else {

            if (excelType === 1) {
              setSalesSuccessState(true);
            } else if (excelType === 2) {
              setRatiosuccessState(true);
            } else if (excelType === 3) {
              setAssemblysuccessState(true);
            } else if (excelType === 4) {
              setInstallationPriceSuccessState(true);
            }
            setresponseMessage(response.data.ErrorDescription)
            setUyariTip("success");
            setUyari(true);
          }

          setLoading(false);
        }).catch(error => {
          setLoading(false);
        });
    }

  }

  const handleExecuteCalculation = () => {
    setLoading(true);
    axios.get('/ExecuteMonthlyBudgetCalculation')
      .then((response) => {
        setLoading(false);
        handleDownloadPredictionInstallation();
      }).catch(err => {
        setLoading(false);
      })
  }

  const handleDownloadPredictionInstallation = () => {
    setLoading(true);
    axios.get('/GetPredictionInstallationBudgetDetail')
      .then((response) => {
        var data = response.data;
        exportToExcel(data);
        setLoading(false);
      }).catch((error) => {
        setLoading(false);
      });
  }

  const exportToExcel = (data) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Montaj Adetleri ve Fiyatları");
    XLSX.writeFile(wb, "Tahminlenen Montaj Adetleri ve Fiyatları.xlsx");
  };

  const handleDownloadExampleExcel = (type) => {
    const urlMap = {
      1: [
        { url: SatisOrnekExcel, name: "1_SatışÖrnekExcelData.xlsx" },
        { url: AnaVeriOrnekExcel, name: "AnaVeriHazırlamaÖrnekExcelData.xlsx" }
      ],
      2: [{ url: MontajOrnekExcel, name: "2_MontajAğırlıkÖrnekExcelData.xlsx" }],
      3: [{ url: FiiliMontajOrnekExcel, name: "3_MontajFiiliAdetÖrnekExceli.xlsx" }],
      4: [{ url: MontajFiyatOrnekExcel, name: "4_FiyatMontajHesaplamaÖrnekExcelData.xlsx" }]
    };
    const files = urlMap[type] || [];

    files.forEach(file => {
      if (file.url) {
        const a = document.createElement("a");
        a.href = file.url;
        a.download = file.name;
        a.click();
      }
    });
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  return (
    <Page className={classes.root}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={uyari}
        autoHideDuration={10000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Müşteri Hizmetleri Bütçe Hesaplama" />
          <Divider />
          <CardContent>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <Stepper alternativeLabel>
                  {steps.slice(0, 4).map((label, index) => (
                    <Step key={label} completed={stepStates[index]}>
                      <StepLabel>
                        {label}
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Grid>

              {/* Kart 1 - Satış Adetleri */}
              <Grid item xs={12} sm={12} md={1} />
              <Grid item xs={12} sm={12} md={4}>
                <Card style={{ backgroundColor: salessuccessState ? "lightgreen" : "white" }}>
                  <CardMedia className={classes.media} image={image} title="Satış Adetleri Excel" />
                  <CardContent className={classes.customCardContent}>
                    <Typography gutterBottom variant="h5" component="h5" style={{ textAlign: "center" }}>
                      Satış Adetleri Excel
                    </Typography>
                    <Divider style={{ marginBottom: "0.6rem", backgroundColor: salessuccessState ? "lightgreen" : "" }} />
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="secondary"
                          size="medium"
                          onClick={() => { handleDownloadExampleExcel(1); }}
                          endIcon={<DownloadIcon />}
                        >
                          Örnek Excel İndir
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button fullWidth variant="contained" color="secondary" size="medium" onClick={() => handleUpload(1)}>
                          Yükle
                          <UploadIcon style={{ marginLeft: "0.3rem" }} />
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Kart 2 - Montajlama Oranı */}
              <Grid item xs={12} sm={12} md={2} />
              <Grid item xs={12} sm={12} md={4}>
                <Card style={{ backgroundColor: ratiosuccessState ? "lightgreen" : "white" }}>
                  <CardMedia className={classes.media} image={image} title="Montajlama Oranı Excel" />
                  <CardContent className={classes.customCardContent}>
                    <Typography gutterBottom variant="h5" component="h5" style={{ textAlign: "center" }}>
                      Montajlama Oranı Excel
                    </Typography>
                    <Divider style={{ marginBottom: "0.6rem", backgroundColor: ratiosuccessState ? "lightgreen" : "" }} />
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="secondary"
                          size="medium"
                          onClick={() => { handleDownloadExampleExcel(2); }}
                          endIcon={<DownloadIcon />}
                        >
                          Örnek Excel İndir
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button fullWidth variant="contained" color="secondary" size="medium" onClick={() => handleUpload(2)}>
                          Yükle
                          <UploadIcon style={{ marginLeft: "0.3rem" }} />
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={1} />
              {/* Kart 3 ve Kart 4 */}
              <Grid item xs={12} sm={12} md={1} />
              <Grid item xs={12} sm={12} md={4}>
                <Card style={{ backgroundColor: assemblysuccessState ? "lightgreen" : "white" }}>
                  <CardMedia className={classes.media} image={image} title="Fiilişen Montaj Adet Excel" />
                  <CardContent className={classes.customCardContent}>
                    <Typography gutterBottom variant="h5" component="h5" style={{ textAlign: "center" }}>
                      Fiilişen Montaj Adet Excel
                    </Typography>
                    <Divider style={{ marginBottom: "0.6rem", backgroundColor: assemblysuccessState ? "lightgreen" : "" }} />
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="secondary"
                          size="medium"
                          onClick={() => { handleDownloadExampleExcel(3); }}
                          endIcon={<DownloadIcon />}
                        >
                          Örnek Excel İndir
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button fullWidth variant="contained" color="secondary" size="medium" onClick={() => handleUpload(3)}>
                          Yükle
                          <UploadIcon style={{ marginLeft: "0.3rem" }} />
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={12} md={2} />
              <Grid item xs={12} sm={12} md={4}>
                <Card style={{ backgroundColor: installationPriceSuccessState ? "lightgreen" : "white" }}>
                  <CardMedia className={classes.media} image={image} title="Montaj Fiyat Excel" />
                  <CardContent className={classes.customCardContent}>
                    <Typography gutterBottom variant="h5" component="h5" style={{ textAlign: "center" }}>
                      Montaj Fiyat Excel
                    </Typography>
                    <Divider style={{ marginBottom: "0.6rem", backgroundColor: installationPriceSuccessState ? "lightgreen" : "" }} />
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="secondary"
                          size="medium"
                          onClick={() => { handleDownloadExampleExcel(4); }}
                          endIcon={<DownloadIcon />}
                        >
                          Örnek Excel İndir
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button fullWidth variant="contained" color="secondary" size="medium" onClick={() => handleUpload(4)}>
                          Yükle
                          <UploadIcon style={{ marginLeft: "0.3rem" }} />
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  columns={columns}
                  rows={rows}
                  disableSelectionOnClick
                  rowsPerPageOptions={[25, 50, 100, 200, 500]}
                  style={{ height: 400, width: "100%" }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={5} />
              <Grid item xs={12} sm={12} md={2}>
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  size="medium"
                  onClick={() => { handleAssemblyAndSalesInsertNewData(); }}
                >
                  Exceli Kaydet
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={5} />
              <Grid item xs={12} sm={12} md={4} />
              <Grid item xs={12} sm={12} md={4}>
                <Typography
                  variant="body1"
                  align='center'
                  color="textSecondary"
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <InfoIcon color="info" style={{ marginRight: 2, fontSize: '2rem' }} />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <b>Dikkat</b>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <b>Hesaplama işlemini yapabilmeniz için dört excel'i de başarıyla yüklemeniz gerekmektedir.</b>
                  </div>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={4} />
              <Grid item xs={12} sm={12} md={4} />
              <Grid item xs={12} sm={12} md={4}>
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  size="medium"
                  disabled={(salessuccessState && ratiosuccessState && assemblysuccessState && installationPriceSuccessState) ? false : true}
                  onClick={() => { handleExecuteCalculation(); }}
                >
                  Hesaplama İşlemini Çalıştır
                </Button>
              </Grid>
              <Grid item xs={12} sm={12} md={4} />
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default AssemblyBudget;
